export default __webpack_public_path__ + "static/media/seaoil-icon.63399abd.svg";